import React from "react";
import style from "./DonateBoy.module.scss";

const DonateBoy = () => {
  return (
    <div className={style.wrapperDonateBoy}>
      <img className={style.donateBoy} src="/assets/girl/boycut.png" alt="" />
    </div>
  );
};

export default DonateBoy;
